export const REGISTERED_USER_EVENT = 'user-registered';
